// First-party pageview beacon. Anonymous (pathname + surface only) and
// fire-and-forget — mirrors the GA SPA pageview but hits our own endpoint, so
// it is operational analytics and not consent-gated.

export type PageViewSurface = 'marketing' | 'portal'

export function recordPageView(surface: PageViewSurface): void {
  if (typeof window === 'undefined') return
  const body = JSON.stringify({ path: window.location.pathname, surface })
  try {
    if (typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function') {
      navigator.sendBeacon('/analytics/page_views', new Blob([body], { type: 'application/json' }))
      return
    }
    void fetch('/analytics/page_views', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body,
      keepalive: true,
    })
  } catch {
    /* best-effort — never block navigation */
  }
}
